import {
  hasRequiredPermissions,
  PermissionKey,
  useCurrentPermissions,
} from '@/hooks/use-current-permissions';
import { PATH } from '@repo/constants';
import { RouterSuspense, Spinner } from '@ui/components';
import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  allOf?: PermissionKey[];
  anyOf?: PermissionKey[];
  children: React.ReactNode;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = (props) => {
  const { allOf = [], anyOf = [], children } = props;
  const { isPending, permissions } = useCurrentPermissions();
  const resolvedIsAllowed = hasRequiredPermissions(permissions, {
    allOf,
    anyOf,
  });

  if (isPending && !permissions) {
    return (
      <div className="flex h-full items-center justify-center py-8">
        <Spinner className="size-10 text-primary" />
      </div>
    );
  }

  if (!resolvedIsAllowed) {
    return <Navigate to={PATH.DASHBOARD} />;
  }

  return <RouterSuspense>{children}</RouterSuspense>;
};
